module.exports = "<span\n  class=\"link--parent\"\n  ng-click=\"$ctrl.backToSearch()\"\n  >\n  &#8592; {{ ::$ctrl.linkText }}\n</span>\n";